export const INVALID_CLASSIC_DOMAIN = 'INVALID_CLASSIC_DOMAIN';
export const INVALID_LIGHTNING_DOMAIN = 'INVALID_LIGHTNING_DOMAIN';

export const SALESFORCE_VALIDATION_ERRORS = {
    INVALID_CLASSIC_DOMAIN: 'Classic domain is not valid. Ex. login.salesforce.com',
    INVALID_LIGHTNING_DOMAIN: 'Lightning domain is not valid. Ex. pitchbook.lightning.force.com',
};

export const CLASSIC_DOMAIN_VALIDATION_CONTROL = 'classic-domain';
export const LIGHTNING_DOMAIN_VALIDATION_CONTROL = 'lightning-domain';
